import React from "react"

import Header from "../../components/Header"
import NavigationButtons from "../../components/NavigationButtons"
import Input from "../../components/Input/Input"

import styles from "../../css/Page.module.css"

const ReplaceExistingUser = props => {
  return (
    <div>
      <Header title="Skall Tidigare användare ersättas?" />
      <div className={styles.inputContainer}>
        <Input
          name="replaceExistingUserChoice"
          inputState={props.inputState}
          onInputChange={props.onInputChange}
        />
      </div>
      {/*<NavigationButtons
        inputState={props.inputState}
  />*/}
    </div>
  )
}
  
export default ReplaceExistingUser